import { siteName } from '@/mocks/homeData';

const footerNav = [
  { label: '热门爆料', href: '#cards' },
  { label: '视频吃瓜', href: '#media' },
  { label: '焦点专题', href: '#carousel' },
  { label: '吃瓜合集', href: '#index' },
  { label: '最新快讯', href: '#updates' },
  { label: '关于我们', href: '#about' },
  { label: '常见问题', href: '#faq' },
  { label: '联系我们', href: '#contact' },
];

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <span className="font-heading text-xl text-background-50">{siteName}</span>
              <p className="text-sm text-background-400 mt-3 leading-relaxed">
                {siteName}是国内领先的娱乐八卦资讯聚合平台，实时更新911吃瓜爆料与911爆料吃瓜网内容，汇聚最新吃瓜、今日爆料、娱乐八卦热门爆料，吃瓜第一手每日更新全网热门爆料。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-100 mb-4">快速导航</h4>
              <ul className="space-y-2">
                {footerNav.slice(0, 4).map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => handleNavClick(e, item.href)}
                      className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-100 mb-4">更多链接</h4>
              <ul className="space-y-2">
                {footerNav.slice(4).map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => handleNavClick(e, item.href)}
                      className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-100 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-500 leading-relaxed">
                合作伙伴信息持续更新中，敬请期待。
              </p>
              <div className="mt-4 flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-700/50 text-background-400 cursor-pointer hover:text-accent-400 transition-colors">
                  <i className="ri-wechat-line text-lg"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-700/50 text-background-400 cursor-pointer hover:text-accent-400 transition-colors">
                  <i className="ri-weibo-line text-lg"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-700/50 text-background-400 cursor-pointer hover:text-accent-400 transition-colors">
                  <i className="ri-mail-line text-lg"></i>
                </span>
              </div>
            </div>
          </div>

          <div className="border-t border-background-700/40 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} {siteName}. 本站内容仅供娱乐参考，转载请注明出处。
            </p>
            <p className="text-xs text-background-500">
              每日更新 · 全网最快 · 吃瓜第一手
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}